













import Component from 'vue-class-component';
import Webview from '@/webview';
import { Prop } from 'vue-property-decorator';

@Component
export default class Tips extends Webview {
  @Prop({
    type: Boolean,
    default: true
  })
  isFast!: boolean;

  tips = [
    '1、请如实填写“病情信息”，帮助医生全面了解您的病情；',
    '2、医生可能因医院工作繁忙不能及时回复，请耐心等待；',
    '3、医生给出医学建议后，经与患者沟通可主动结束咨询，咨询时间超出24小时后，系统将自动结束；',
    '4、如医生未回复咨询，系统将在24小时后自动结束。',
    '5、快速问诊为医疗服务项目，一旦支付，不允许退款，请谨慎支付。'
  ];

  get tipList() {
    if (this.isFast) {
      return this.tips;
    }
    return this.tips.splice(0, 4);
  }
}
